import React from "react";
import {Link as RouterLink} from "react-router-dom";
import {useTranslation} from 'react-i18next';
import "./nav.scss"

const Nav = () => {
  const { t } = useTranslation();

  return (
    <ul className="mainmenu">
      <li className="has-droupdown">

          <RouterLink to="/#megoldasok">{t('nav.products')}</RouterLink>

        <ul className="submenu">
            <li>
                <RouterLink to="/erp-vallalatiranyitasi-rendszer">{t('nav.erp')}</RouterLink>
            </li>
            <li>
                <RouterLink to="/crm-rendszer">{t('nav.crm')}</RouterLink>
            </li>
            <li>
                <RouterLink to="/trade-kereskedelmi-rendszer">{t('nav.trade')}</RouterLink>
            </li>
            <li>
                <RouterLink to="/gastro-ettermi-szoftver">{t('nav.gastro')}</RouterLink>
            </li>
            <li>
                <RouterLink to="/service-idopontfoglalo-app">{t('nav.serviceApp', { defaultValue: 'Happy Service App' })}</RouterLink>
            </li>
            <li>
                <RouterLink to="/logistic-app">{t('nav.logisticApp', { defaultValue: 'Happy Logistic App' })}</RouterLink>
            </li>
            <li>
                <RouterLink to="/services-idopontfoglalo-rendszer">{t('nav.service')}</RouterLink>
            </li>

        </ul>
      </li>
      <li>
        <RouterLink to="/profilom">{t('nav.profile')}</RouterLink>
      </li>

      {/*<li className={"has-droupdown"}>*/}
      {/*  <RouterLink to="/szolgaltatasok/arajanlat">{t('nav.quote')}</RouterLink>*/}
      {/*  <ul className="submenu">*/}
      {/*    <li>*/}
      {/*      <RouterLink to="/szolgaltatasok/arajanlat/csomag-arak">*/}
      {/*        {t('nav.packagePrices')}*/}
      {/*      </RouterLink>*/}
      {/*    </li>*/}
      {/*    <li>*/}
      {/*      <RouterLink to="/szolgaltatasok/arajanlat/modul-arak">*/}
      {/*        {t('nav.modulePrices')}*/}
      {/*      </RouterLink>*/}
      {/*    </li>*/}
      {/*    <li>*/}
      {/*      <RouterLink to="/szolgaltatasok/arajanlat/szolgaltatas-arak">*/}
      {/*        {t('nav.servicePrices')}*/}
      {/*      </RouterLink>*/}
      {/*    </li>*/}
      {/*  </ul>*/}
      {/*</li>*/}

        <li>
            <RouterLink to="/palyazat">{t('nav.palyazat')}</RouterLink>
        </li>
        <li>
            <RouterLink to="/kapcsolat/elerhetosegeink">{t('nav.contact', { defaultValue: 'Kapcsolat' })}</RouterLink>
        </li>
    </ul>
  );
};
export default Nav;
